import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import "./App.css";
import Logo from "./imagens/logo.png";
import Play from "./remotion/play";
import React, { useEffect, useState, useRef } from 'react';
import ProdutosAdicionados from "./components/produtos/produtos-adicionados"
import AdicionarProdutos from './components/produtos/adicionar-produtos';
import EditarProduto from './components/produtos/editar-produto';
import Locucao from './components/locucao';
import Admin from "./components/admin";
import Temas from "./components/temas";
import Musicas from "./components/musicas"
import Topo from "./components/Topo"
import Personalizar from "./components/personalizar"
import Ofertas from "./components/ofertas"
import BeginnerTips from "./components/BeginnerTips";
import TutorialModal from "./components/TutorialModal";
import Precos from "./components/precos";

function Home() {

  const [visivel, setVisivel] = useState('temas');
  const [produtos, setProdutos] = useState([]);
  const [video, setVideo] = useState({});
  const [playerKey, setPlayerKey] = useState(0);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const [creditos, setCreditos] = useState(0);
  const [user, setUser] = useState(null);
  const playRef = useRef(null);
  const [audioGravadoUrl, setAudioGravadoUrl] = useState(null);
  const [modoGravando, setModoGravando] = useState(false);
  const [gravandoMobilePopup, setGravandoMobilePopup] = useState(false);

  const [beginnerMode, setBeginnerMode] = useState(() => {
    try {
      const raw = localStorage.getItem('beginnerMode');
      if (raw === null) return true;
      return raw === '1' || raw === 'true';
    } catch {
      return true;
    }
  });

  const [criandoVideo, setCriandoVideo] = useState(false);
  const [createVideoMessage, setCreateVideoMessage] = useState(null);
  const [showTutorial, setShowTutorial] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const currentId = urlParams.get('id');
  const hasVideo = Boolean(currentId);

  useEffect(() => {
    try {
      localStorage.setItem('beginnerMode', beginnerMode ? '1' : '0');
    } catch {
      // ignore
    }
  }, [beginnerMode]);

  useEffect(() => {
    const userStorage = sessionStorage.getItem("user");
    if (!userStorage) return;

    const user = JSON.parse(userStorage);
    setUser(user);

    fetch(`https://videooferta.com/api/saldo.php?id_user=${user.id}`)
      .then(res => res.json())
      .then(data => {
        if (!data.erro) {
          setCreditos(data.saldo);
        }
      });
  }, []);

  function carregarVideo() {
    if (!currentId) {
      setVideo({});
      setProdutos([]);
      return;
    }

    fetch(`https://videooferta.com/api/video.php?id=${currentId}`)
      .then(response => response.json())
      .then(data => setVideo(data))
      .catch(error => console.error('Erro ao buscar encartes:', error));

    fetch(`https://videooferta.com/api/listarProdutos.php?id=${currentId}`)
      .then(response => response.json())
      .then(data => setProdutos(data))
      .catch(error => console.error('Erro ao buscar dados:', error));
  }

  useEffect(() => {
    carregarVideo();
  }, [currentId]);

  // Mobile: fechar menu e mostrar popup quando gravação inicia
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (modoGravando && isMobile) {
      setGravandoMobilePopup(true);
    } else if (!modoGravando && gravandoMobilePopup) {
      setGravandoMobilePopup(false);
      // Após parar gravação, play automático
      setTimeout(() => {
        playRef.current?.seekTo?.(0);
        setTimeout(() => playRef.current?.play?.(), 100);
      }, 600);
    }
  }, [modoGravando]);

  const handlePararGravacaoMobile = () => {
    // Simula parar via playRef (locucao observa o frame e para)
    playRef.current?.pause?.();
    setModoGravando(false);
  };

  const handleToggleBeginnerMode = () => {
    setBeginnerMode((prev) => !prev);
  };

  const handleCreateNewVideo = async () => {
    if (!user?.id) {
      setCreateVideoMessage({ type: 'error', text: 'Sessão inválida. Faça login novamente.' });
      return;
    }

    setCriandoVideo(true);
    setCreateVideoMessage(null);

    try {
      const res = await fetch('https://videooferta.com/api/criar-video.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id_user: user.id, formato: 'story' })
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();
      if (data?.success && data?.id_publico) {
        window.location.href = `/?id=${encodeURIComponent(data.id_publico)}`;
        return;
      }

      setCreateVideoMessage({
        type: 'error',
        text: data?.error || 'Não foi possível criar um novo vídeo.'
      });
    } catch {
      setCreateVideoMessage({ type: 'error', text: 'Erro ao conectar com o servidor.' });
    } finally {
      setCriandoVideo(false);
    }
  };

  return (
    <>
      <div className="layout">
        <Topo
          creditos={creditos}
          beginnerMode={beginnerMode}
          onToggleBeginnerMode={handleToggleBeginnerMode}
          onAbrirTutorial={() => setShowTutorial(true)}
        />

        <div className="geral">

          <BeginnerTips
            enabled={beginnerMode}
            hasVideo={hasVideo}
            produtos={produtos}
            video={video}
            setVisivel={setVisivel}
          />

          <div className="col1">
            <nav className="menu">
              {[
                { id: "temas", label: "Temas", icon: (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="7" height="7" rx="1.5" />
                    <rect x="14" y="3" width="7" height="7" rx="1.5" />
                    <rect x="3" y="14" width="7" height="7" rx="1.5" />
                    <rect x="14" y="14" width="7" height="7" rx="1.5" />
                  </svg>
                )},
                { id: "produtos", label: "Produtos", icon: (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
                    <path d="M3 6h18" />
                    <path d="M16 10a4 4 0 01-8 0" />
                  </svg>
                )},
                { id: "locucao", label: "Locução", icon: (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2a3 3 0 00-3 3v7a3 3 0 006 0V5a3 3 0 00-3-3z" />
                    <path d="M19 10v2a7 7 0 01-14 0v-2" />
                    <path d="M12 19v3" />
                    <path d="M8 22h8" />
                  </svg>
                )},
                { id: "personalizar", label: "Personalizar", icon: (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 21V14" />
                    <path d="M4 10V3" />
                    <path d="M12 21V12" />
                    <path d="M12 8V3" />
                    <path d="M20 21V16" />
                    <path d="M20 12V3" />
                    <path d="M1 14h6" />
                    <path d="M9 8h6" />
                    <path d="M17 16h6" />
                  </svg>
                )},
                { id: "musicas", label: "Música", icon: (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 18V5l12-2v13" />
                    <circle cx="6" cy="18" r="3" />
                    <circle cx="18" cy="16" r="3" />
                  </svg>
                )},
              ].map((item) => (
                <button
                  key={item.id}
                  className={`botao-menu${visivel === item.id ? " ativo" : ""}`}
                  onClick={() => setVisivel(item.id)}
                  disabled={!hasVideo}
                  title={!hasVideo ? "Crie um vídeo para começar" : item.label}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </button>
              ))}

              {user?.nivel === "admin" && (
                <button
                  className="botao-menu"
                  data-bs-toggle="modal"
                  data-bs-target="#adminModal"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                  <span>Admin</span>
                </button>
              )}
            </nav>

            {/* Meus Vídeos — footer da sidebar */}
            <div className="sidebar-footer">
              <div className="sidebar-divider" />
              <button
                className={`sidebar-videos-btn${visivel === 'ofertas' ? ' sidebar-videos-btn--active' : ''}`}
                onClick={() => setVisivel('ofertas')}
                title="Meus Vídeos"
              >
                <span className="sidebar-videos-btn__icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <path d="M2 8h20" />
                    <path d="M10 12l4 2.5-4 2.5v-5z" fill="currentColor" stroke="none" />
                  </svg>
                </span>
                <span className="sidebar-videos-btn__label">Ofertas</span>
              </button>
            </div>

            <div
              className="modal fade"
              id="adminModal"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-xl">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      <i className="fa-solid fa-lock me-2"></i>
                      Painel Admin
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <Admin />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!hasVideo ? (
            visivel === 'ofertas' ? (
              <Ofertas
                user={user}
                setVisivel={setVisivel}
              />
            ) : (
            <div
              className="flex-grow-1 d-flex align-items-center justify-content-center p-4"
              style={{ width: '100%' }}
            >
              <div className="card shadow-sm" style={{ maxWidth: 560, width: '100%', borderRadius: 16 }}>
                <div className="card-body p-4">
                  <h4 className="mb-2" style={{ color: '#0F0A15' }}>Comece criando um novo vídeo</h4>
                  <p className="mb-3" style={{ color: '#5C4A63' }}>
                    Você entrou no editor sem selecionar um vídeo. Crie um novo e siga o passo a passo.
                  </p>

                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleCreateNewVideo}
                    disabled={criandoVideo}
                  >
                    {criandoVideo ? 'Criando...' : 'Criar novo Vídeo'}
                  </button>

                  {createVideoMessage && (
                    <div
                      className={`mt-3 alert ${createVideoMessage.type === 'error' ? 'alert-danger' : 'alert-info'} mb-0`}
                      role="alert"
                    >
                      {createVideoMessage.text}
                    </div>
                  )}
                </div>
              </div>
            </div>
            )
          ) : (
            <>
              {visivel === 'produtos' && (
                <ProdutosAdicionados
                  produtos={produtos}
                  setVisivel={setVisivel}
                  setProdutoSelecionado={setProdutoSelecionado}
                  setProdutos={setProdutos}
                  video={video}
                />
              )}

              {visivel === 'add-produto' && (
                <AdicionarProdutos
                  produtos={produtos}
                  setVisivel={setVisivel}
                  setProdutos={setProdutos}
                  onAddProdutos={carregarVideo}
                  setProdutoSelecionado={setProdutoSelecionado}
                  user={user}
                  creditos={creditos}
                  setCreditos={setCreditos}
                />
              )}

              {visivel === 'editar-produto' && (
                <EditarProduto
                  setVisivel={setVisivel}
                  produto={produtoSelecionado}
                  onAddProdutos={carregarVideo}
                  user={user}
                  creditos={creditos}
                  setCreditos={setCreditos}
                />
              )}

              {visivel === 'temas' && (
                <Temas
                  video={video}
                  onUpdate={carregarVideo}
                  setVisivel={setVisivel}
                />
              )}

              {visivel === 'personalizar' && (
                <Personalizar
                  video={video}
                  setVisivel={setVisivel}
                  setVideo={setVideo}
                  onUpdate={carregarVideo}
                  user={user}
                  creditos={creditos}
                  setCreditos={setCreditos}
                />
              )}

              {visivel === 'musicas' && (
                <Musicas
                  video={video}
                  setVideo={setVideo}
                  onUpdate={carregarVideo}
                  setVisivel={setVisivel}
                  user={user}
                  creditos={creditos}
                />
              )}

              {(visivel === 'locucao' || modoGravando) && (
                <div style={visivel !== 'locucao' ? { display: 'none' } : undefined}>
                  <Locucao
                    video={video}
                    produtos={produtos}
                    onLocucaoGerada={carregarVideo}
                    setVisivel={setVisivel}
                    user={user}
                    creditos={creditos}
                    playRef={playRef}
                    setAudioGravadoUrl={setAudioGravadoUrl}
                    setModoGravando={setModoGravando}
                    modoGravando={modoGravando}
                  />
                </div>
              )}

              {visivel === 'ofertas' && (
                <Ofertas
                  user={user}
                  setVisivel={setVisivel}
                />
              )}

              <div className={`col3${visivel ? ' col3--menu-open' : ''}`}>
                <Play
                  ref={playRef}
                  user={user}
                  creditos={creditos}
                  produtos={produtos}
                  video={video}
                  setCreditos={setCreditos}
                  audioGravadoUrl={audioGravadoUrl}
                  modoGravando={modoGravando}
                />
              </div>
            </>
          )}

        </div>
      </div>
      <TutorialModal open={showTutorial} onClose={() => setShowTutorial(false)} />

      {/* Modal de compra de créditos — sempre montado (mesmo sem vídeo aberto) */}
      <Precos user={user} creditos={creditos} setCreditos={setCreditos} />

      {/* Popup de gravação mobile */}
      {gravandoMobilePopup && (
        <div className="gravando-mobile-popup" onClick={handlePararGravacaoMobile}>
          <div className="gravando-mobile-pulse" />
          <span>Gravando...</span>
          <small>Toque para parar</small>
        </div>
      )}
    </>
  );
}

export default Home;
